import React, { useRef, useState ,useEffect} from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme, ButtonSize } from '../../atoms/button/button';
import { IconType, IconSize } from '../../atoms/icon/icon';
import './formFooter.scss';
import Checkbox from '../../atoms/checkbox/checkbox';

const FormFooterWizard = (props) => {
  const {
    idNext,idBack,idFinish, idYamlSent,idYamlSignaling,idSignaling,idSaveTemplate,type, theme, size, onNext,onBack,onFinish,
    onYamlSent, onSaveTemplate,onBlur, children, icon, iconColor, iconSize, visibleNext,visibleFinish,visibleDisplaySignaling,visibleDisplayYaml,onDisplaySignaling,onDisplayYaml,
    visibleYamlSent,disabledBack,disabledNext,disabledFinish, propagate,formHasChanged,
    navigationBlockReaders,page,userNavigation,myEmail
  } = props;
  
  const childRef = useRef();
  const [propagateState, setPropate] = useState(false);
  const [isMaster,setIsMaster] =useState(true);
  const handleChangeCheckbox = () => {
    setPropate(!propagateState);
  };

  useEffect(() => {
   if(userNavigation){
    userNavigation.forEach((item)=>{
      if(item.email==myEmail){
          setIsMaster(item.first);
      }      
    });
   }
  }, [userNavigation]);
  if (childRef.current) {
    childRef.current.updateValue(propagateState);
  }

  return (
    <div className='footer-section'>
      <div className="footer-button floatleft">
        <div className="px-3 pb-3 clearfix">
          <Button
            id={idBack}
            type={type}
            onClick={() => onBack(propagateState)}
            onBlur={onBlur}
            disabled={disabledBack}
            icon={icon}
            iconSize={iconSize}
            iconColor={iconColor}
            theme={theme}
            size={size}
          >
            Back
          </Button>
        </div>
      </div>
   
        {visibleNext && 
           <div className='footer-button floatright'>
            <div className="px-3 pb-3 clearfix">
            <Button
          id={idNext}
          className="float-right"
          type={type}
          onClick={() => onNext(propagateState)}
          onBlur={onBlur}
          disabled={disabledNext}
          icon={icon}
          iconSize={iconSize}
          iconColor={iconColor}
          theme={theme}
          size={size}
        >
            {(formHasChanged? (navigationBlockReaders && !isMaster?"Only Next(Reader)":"Save and Next"):"Next")}
        </Button>
        </div>
        </div>}
        
        {page=="lives" && formHasChanged==false && visibleDisplayYaml && visibleFinish &&
        <div className='footer-button floatright'>
         <div className="px-3 pb-3 clearfix">
            <Button
                id={idYamlSignaling}
                className="float-right ml-2 mr-2"
                type={type}
                onClick={() => onDisplayYaml(propagateState)}
                onBlur={onBlur}
                // disabled={disabledFinish}
                icon={icon}
                iconSize={iconSize}
                iconColor={iconColor}
                theme={theme}
                size={size}
                disabled={navigationBlockReaders==true && isMaster==false}
              >
                {"Display YAML"}

            </Button>
        </div></div>}
        
        {page=="lives" && formHasChanged==false && visibleDisplaySignaling && visibleFinish && 
          <div className='footer-button floatright'>
            <div className="px-3 pb-3 clearfix">
            <Button
            id={idSignaling}
            className="float-right ml-2 mr-2"
            type={type}
            onClick={() => onDisplaySignaling(propagateState)}
            onBlur={onBlur}
            // disabled={disabledFinish}
            icon={icon}
            iconSize={iconSize}
            iconColor={iconColor}
            theme={theme}
            size={size}
            disabled={navigationBlockReaders==true && isMaster==false}
          >
            {"Display Signaling"}

        </Button>
        </div></div>}
        {page=="lives" && formHasChanged==false && visibleFinish && 
          <div className='footer-button floatright'>
             <div className="px-3 pb-3 clearfix">
            <Button
            id={idYamlSent}
            className="float-right ml-2 mr-2"
            type={type}
            onClick={() => onYamlSent(propagateState)}
            onBlur={onBlur}
            // disabled={disabledFinish}
            icon={icon}
            iconSize={iconSize}
            iconColor={iconColor}
            theme={theme}
            size={size}
            disabled={navigationBlockReaders==true && isMaster==false}
          >
            {"Send Yaml to liveBackendApi"}

        </Button>
          </div>
        </div>
        }
        {page=="lives" && formHasChanged==false && visibleFinish && 
          <div className='footer-button floatright'>
            <div className="px-3 pb-3 clearfix">
            <Button
            id={idSaveTemplate}
            className="float-right ml-2 mr-2"
            type={type}
            onClick={() => onSaveTemplate(propagateState)}
            onBlur={onBlur}
            // disabled={disabledFinish}
            icon={icon}
            iconSize={iconSize}
            iconColor={iconColor}
            theme={theme}
            size={size}
          >
            {"Save as template"}

            </Button>
            </div>
          </div>
            }
        {formHasChanged && visibleFinish && 
          <div className='footer-button floatright'>
            <div className="px-3 pb-3 clearfix">
            <Button
            id={idFinish}
            className="float-right"
            type={type}
            onClick={() => onFinish(propagateState)}
            onBlur={onBlur}
            disabled={disabledFinish}
            icon={icon}
            iconSize={iconSize}
            iconColor={iconColor}
            theme={theme}
            size={size}
          >
            {(formHasChanged?(navigationBlockReaders && !isMaster?"Only Next(Reader)":"Save and Finish"):"Finish")}

        </Button></div></div>}
          { /*propagate
          && (
            <Checkbox
              className="d-inline"
              ref={childRef}
              onChange={ChangeCheckbox}
            >
              Propagate changes
            </Checkbox>
          )*/}
      </div>
  );
};

FormFooterWizard.propTypes = {
  /**
   * Id of save button
   */
  id: PropTypes.string,
  /**
   * HTML attribute type
   */
  type: PropTypes.oneOf(Object.values(ButtonType)),
  /**
   * Button background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Button general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
  /**
   * Function to bind click HTML functionality
   */
  onClick: PropTypes.func,
  /**
   * Function to bind onBlur HTML functionality
   */
  onBlur: PropTypes.func,
  /**
   * Content to put inside the Button component
   */
  children: PropTypes.node,
  /**
   * To select a icon inside the button
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the button
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the button
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the button functionality
   */
  disabled: PropTypes.bool,
  /**
   * To enable propagate button
   */
  propagate: PropTypes.bool,
};

FormFooterWizard.defaultProps = {
  id:'',
  type: ButtonType.BUTTON,
  theme: ButtonTheme.PRIMARY,
  size: ButtonSize.SMALL,
  onClick: () => {},
  onBlur: () => {},
  children: null,
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
  disabledBack:false,
  disabledNext:false,
  disabledFinish:false,
  visibleNext:true,
  visibleFinish:false,
  propagate: false,
  formHasChanged:false
};

export default FormFooterWizard;
